import React from 'react';
import mafia1 from '../Assets/IMG/iron.png';
import mafia2 from '../Assets/IMG/hulk.png';
import mafia3 from '../Assets/IMG/Cap.png';
import bgMain from '../Assets/IMG/BG_02.gif';

import spiderTop from '../Assets/IMG/Spider.png';
import goblinTop from '../Assets/IMG/goblien.png';

import redBg from '../Assets/IMG/bg-iron.png';
import blueBg from '../Assets/IMG/bg-hunk.png';
import purpleBg from '../Assets/IMG/bg-cap.png';

import mafia4 from '../Assets/IMG/iron-man-big.png';
import mafia5 from '../Assets/IMG/hunk-bg.png';
import mafia6 from '../Assets/IMG/Captain-America (1).png';


const ContactPitchCards = () => {
  return (
    <>
      <style>{`
        .pitch-container {
          display: flex;
          flex-wrap: wrap;
          justify-content: center;
          gap: 30px;
          padding: 100px 20px 60px;
          font-family: 'Montserrat', sans-serif;
          background-size: cover;
          background-position: center;
          position: relative;
        }

        .card-wrapper {
          position: relative;
          flex: 1 1 340px;
          max-width: 422px;
        }

        .top-spiderman {
          position: absolute;
          top: -250px;
          left: 0%;
          transform: translateX(-50%);
          width: 250px;
          height: auto;
          z-index: 2;
          animation: spidermanJump 2s ease-in-out infinite;
        }

        @keyframes spidermanJump {
          0%, 100% {
            transform: translateY(0) translateX(-50%);
          }
          50% {
            transform: translateY(-30px) translateX(-50%);
          }
        }

        .top-goblin {
          position: absolute;
          top: -250px;
          right: 50px;
          transform: translateX(25%);
          width: 250px;
          height: auto;
          z-index: 2;
          animation: goblinRun 1s ease-in-out infinite;
        }

        @keyframes goblinRun {
          0%, 100% {
            transform: translateY(0) translateX(25%);
          }
          50% {
            transform: translateY(-15px) translateX(25%);
          }
        }

        .pitch-card {
          position: relative;
          color: #fff;
          padding: 40px 25px;
          text-align: center;
          min-height: 420px;
          background-size: cover;
          background-position: center;
          border-radius: 20px;
          z-index: 1;
        }

        .pitch-title-wrapper {
          opacity: 0;
          transform: translateY(20px) scale(0.95);
          transition: all 0.5s ease-in-out;
          position: relative;
          z-index: 2;
          margin-top: 30px;
        }

        .card-wrapper:hover .pitch-title-wrapper {
          opacity: 1;
          transform: translateY(0px) scale(1);
        }

        .pitch-title {
          font-size: 20px;
          font-weight: 700;
          margin-bottom: 10px;
          line-height: 1.4;
        }

        .pitch-subtext {
          font-size: 16px;
          font-weight: 400;
        }

        .pitch-image {
          position: absolute;
          bottom: 0;
          left: 50%;
          transform: translateX(-50%);
          width: 320px;
          height: auto;
          transition: transform 1.5s ease, opacity 1.5s ease;
        }

        .small-icon {
          position: absolute;
          bottom: -100px;
          left: 50%;
          transform: translateX(-50%);
          width: 180px;
          height: auto;
          opacity: 0;
          transition: opacity 0.3s ease;
          z-index: 3;
          
        }

        .card-wrapper:hover .pitch-image {
          opacity: 0;
          transform: translateX(-50%) scale(0.6);
        }

        .card-wrapper:hover .small-icon {
          opacity: 1;
        }

        @media (max-width: 768px) {
          .pitch-container {
            padding: 60px 15px;
          }

          .pitch-card {
            min-height: 380px;
            padding-bottom: 100px;
          }

          .top-spiderman {
            top: -80px;
            width: 90px;
          }

          .top-goblin {
            top: -90px;
            width: 100px;
          }

          .pitch-image {
            width: 140px;
            bottom: -80px;
          }

          .small-icon {
            width: 80px;
            bottom: -70px;
          }
        }

        @media (max-width: 480px) {
          .pitch-title {
            font-size: 16px;
          }

          .pitch-subtext {
            font-size: 14px;
          }

          .top-spiderman {
            width: 70px;
          }

          .top-goblin {
            width: 80px;
          }

          .pitch-image {
            width: 120px;
            bottom: -60px;
          }

          .small-icon {
            width: 70px;
            bottom: -60px;
          }
        }
      `}</style>

      <div className="pitch-container" style={{ backgroundImage: `url(${bgMain})` }}>
        <div className="card-wrapper">
          <img src={spiderTop} alt="Spider-Man" className="top-spiderman" />
          <div className="pitch-card" style={{ backgroundImage: `url(${redBg})` }}>
            <div className="pitch-title-wrapper">
              <div className="pitch-title">
                Like Iron Man, we combine<br/> tech + strategy
                Social media<br/> management, ads management, YouTube handling & organic<br/> growth engineered to make <br/>your brand invincible in<br/> the digital world.
              </div>
            </div>
            <img src={mafia4} alt="Mafia 4" className="pitch-image" />
            <img src={mafia1} alt="Iron Man Small" className="small-icon" />
          </div>
        </div>

        <div className="card-wrapper">
          <div className="pitch-card" style={{ backgroundImage: `url(${blueBg})` }}>
            <div className="pitch-title-wrapper">
              <div className="pitch-title">
                Smash the ordinary with Hulk<br/>sized creativity
                Our video<br/> production, graphic designing,<br/> and branding deliver bold visuals <br/>and unstoppable impact  built to dominate screens and win attention.
              </div>
            </div>
            <img src={mafia5} alt="Mafia 5" className="pitch-image" />
            <img src={mafia2} alt="Hulk Small" className="small-icon" />
          </div>
        </div>

        <div className="card-wrapper">
          <img src={goblinTop} alt="Goblin" className="top-goblin" />
          <div className="pitch-card" style={{ backgroundImage: `url(${purpleBg})` }}>
            <div className="pitch-title-wrapper">
              <div className="pitch-title">
                Built like Cap’s shield sleek <br/>strong unshakable
                Our <br/> website development and SEO services are your brand’s<br/> frontline defense built for speed<br/> structure and search engine supremacy.
              </div>
            </div>
            <img src={mafia6} alt="Mafia 6" className="pitch-image" />
            <img src={mafia3} alt="Cap Small" className="small-icon" />
          </div>
        </div>
      </div>
    </>
  );
};

export default ContactPitchCards;
